import { FC } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectLivingArea } from 'shared/selectors/jsonQuery';

export const LivingAreaContainer: FC = () => {
  const { gte: valueMin = null, lte: valueMax = null } = useSelector(selectLivingArea);

  const onChange = useFilterChangeCallback();

  const handleMinValueChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setLivingAreaMin', arguments: [value] });
  });

  const handleMaxValueChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setLivingAreaMax', arguments: [value] });
  });

  return (
    <InlineFilter width={100} label="Жилая" dataTestId="livingArea">
      <RangeInput
        min={1}
        max={9999}
        valueMin={valueMin}
        valueMax={valueMax}
        onChangeMin={handleMinValueChange}
        onChangeMax={handleMaxValueChange}
      />
    </InlineFilter>
  );
};
